import { StaticImageData } from 'next/image'

import {
  ExploreOurMembershipsCorporateImage,
  ExploreOurMembershipsIndividualImage,
} from 'Assets/Images/Sections/ExploreOurMemberships'

import { MEMBERSHIPS_CORPORATE, MEMBERSHIPS_INDIVIDUAL } from 'Constants/Paths'

type ExploreOurMembershipsPointBenefitItem = {
  id: string
  text: string
}

export type ExploreOurMembershipsPointItem = {
  id: string
  image: StaticImageData
  imageAlt: string
  buttonCaption?: string
  link: string
  title: string
  plainText: string
  benefits: ExploreOurMembershipsPointBenefitItem[]
}

export const EXPLORE_OUR_MEMBERSHIPS_POINT_ITEMS: ExploreOurMembershipsPointItem[] =
  [
    {
      id: 'ExploreOurMembershipsPointItem-001',
      image: ExploreOurMembershipsIndividualImage,
      imageAlt: '',
      buttonCaption: 'Learn More',
      link: MEMBERSHIPS_INDIVIDUAL,
      title: 'Individual Memberships',
      plainText:
        'Perfect for the solopreneur looking to grow their business, find like minded business owners to share insights and experiences with, and grow their network while enjoying a day out on the course.',
      benefits: [
        {
          id: 'ExploreOurMembershipsPointItem-001-Benefit-001',
          text: 'Build relationships in a very native and natural way.',
        },
        {
          id: 'ExploreOurMembershipsPointItem-001-Benefit-002',
          text: 'Learn from the best to become a better business leader.',
        },
        {
          id: 'ExploreOurMembershipsPointItem-001-Benefit-003',
          text: 'Enjoy a day out on the course or improve your technique.',
        },
      ],
    },
    {
      id: 'ExploreOurMembershipsPointItem-002',
      image: ExploreOurMembershipsCorporateImage,
      imageAlt: '',
      buttonCaption: 'Benefit From Your Investment',
      link: MEMBERSHIPS_CORPORATE,
      title: 'Corporate Memberships',
      plainText:
        'Beyond the extensive networking opportunities available to you, we also offer the chance for hole sponsorships and event naming rights, as well as social media and EDM promotional opportunities throughout the year to connect with more clients.',
      benefits: [
        {
          id: 'ExploreOurMembershipsPointItem-002-Benefit-001',
          text: 'Build brand awareness across the network and online.',
        },
        {
          id: 'ExploreOurMembershipsPointItem-002-Benefit-002',
          text: 'Give your team the opportunity to play golf and network with successful business executives.',
        },
        {
          id: 'ExploreOurMembershipsPointItem-002-Benefit-003',
          text: 'Boost morale and wellness among your team and clients.',
        },
      ],
    },
  ]
